module.exports = {"DEFAULT":{"PRICE":"0 $/h","DESCRIPTION":""}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/vi.json
// module id = 6nWv
// module chunks = 2